import { RefServiceType } from "./Ref.dto";
import { LoLang } from "../common/common.types";

export function ReadableRefServiceType(serviceType: RefServiceType, lang?: LoLang | undefined, defaultVal = "-"): string {
  switch (serviceType) {
    case RefServiceType.Suite:
      return "Maven Clinical Cloud";
    case RefServiceType.Cdms:
      return "Maven CDMS";
    case RefServiceType.CdmsDw:
      return "Maven CDMS (DW)";
    case RefServiceType.CdmsStudy:
      return "Maven CDMS (Study)";
    case RefServiceType.Docs:
      return "Maven Docs";
    case RefServiceType.DocsPdf:
      return "Maven Docs (PDF)";
    case RefServiceType.Vdr:
      return "Maven VDR";
    case RefServiceType.Tmf:
      return "Maven TMF";
    case RefServiceType.Safety:
      return "Maven Safety";
    case RefServiceType.Builder:
      return "Maven Builder";
    case RefServiceType.Resource:
      return "Maven Resource";
    case RefServiceType.SSO:
      return "Maven SSO";
    case RefServiceType.Auth:
      return "Maven Auth";
    case RefServiceType.Portal:
      return "Maven Portal";
    case RefServiceType.Project:
      return "Maven Project";
    case RefServiceType.Billing:
      return "Maven Billing";
    case RefServiceType.Validator:
      return "Maven Validator";
    case RefServiceType.ERecruitment:
      return "Maven eRecruitment";
    case RefServiceType.Converter:
      return "Maven Converter";
    case RefServiceType.ConverterValidator:
      return "Maven Converter (Validator)";
    case RefServiceType.ConverterXslt:
      return "Maven Converter (XSLT)";
    case RefServiceType.Paths:
      return "Paths";
    case RefServiceType.X:
      return "Maven X";
    case RefServiceType.TNE:
      return "Maven TNE";
    default:
      return serviceType || defaultVal;
  }
}
